import * as React from 'react'
import TextField from '@mui/material/TextField'
import Autocomplete from '@mui/material/Autocomplete'
import { styled } from "@mui/material/styles";

const Root = styled("div")(({ theme }) => ({
  width: "100%",
  "& label.Mui-focused": {
    color: "black",
  },
  "& .MuiListSubheader-root": {
    backgroundColor: "red",
  },
  "& .MuiAutocomplete-clearIndicator": {
    display: "none",
  },
  "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
    border: "1px solid rgba(0, 0, 0, 0.5)",
  },
  "& .MuiAutocomplete-listbox": {
    maxHeight: 200,
    overflowY: "auto",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      border: "1px solid rgba(0, 0, 0, 0.5)",
      borderRadius: "8px",
    },
    "&:hover fieldset": {
      border: "1px solid rgba(0, 0, 0, 0.5)",
    },
    "&.Mui-focused fieldset": {
      border: "1px solid rgba(0, 0, 0, 0.5)",
    },
  },
  "&::-webkit-scrollbar": {
    width: "2px",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#888",
    borderRadius: "6px",
  },
  "&::-webkit-scrollbar-thumb:hover": {
    backgroundColor: "#555",
  },
}));

export default function ComboBox ({
  records,
  type,
  setType,
  label,
  error,
  helperText
}) {

  //  React.useEffect(() => {
  //   if (!type) {
  //     setType("All");
  //   }
  // }, [type, setType]);

  return (
    <Root className="searchMenu-loc lg:px-0 js-form-dd">
      <Autocomplete
        size='small'
        disablePortal
        id='combo-box-demo'
        value={type}
        options={records}
        onChange={(e, newValue) => setType(newValue)}
        fullWidth
        renderInput={params => (
          <TextField
            {...params}
            label={label}
            InputProps={{
              ...params.InputProps,
              style: error ? { borderColor: 'red' } : {}
            }}
            error={error}
            helperText={helperText}
          />
        )}
      />
    </Root>
  )
}
